import { markUiObject as __markUi } from '@/i18n/display'
// 仅订单逐笔列表补充订单留言；不与客户账号备注、量体备注合并。
export function withOrderMessage(columns:any[],enabled:boolean):any[] {
  if(!enabled)return columns
  const exists=columns.some(c=>c.dataIndex==='leaveMessage')
  const result=columns.map(c=>c.dataIndex==='leaveMessage'?__markUi({...c,title:'留言',dataIndex:'leaveMessage',key:'leaveMessage'}, {"title":"留言"}):c)
  if(exists)return result
  if(!result.some(c=>['productName','drawingOrderNumber','drawingStyle'].includes(c.dataIndex)))return columns
  const anchor=result.findIndex(c=>c.dataIndex==='customerMemo' || /^(orderTime|createTime|drawingOrderAt|drawingCreatedAt)$/.test(c.dataIndex))
  const action=result.findIndex(c=>/^(commands?|operations?|refound|designerName)$/.test(c.dataIndex))
  result.splice(anchor>=0?anchor:action>=0?action:result.length,0,__markUi({title:'留言',dataIndex:'leaveMessage',key:'leaveMessage',width:150}, {"title":"留言"}))
  return result
}
